import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';
import { ADButtonModule } from '@internal/common-ui/ad-button';
import { ADInputModule } from '@internal/common-ui/ad-input';
import { ADSharedModule } from '@internal/common-ui/ad-shared';
import { VirtualScrollerModule } from '@iharbeck/ngx-virtual-scroller';
import { AdBreadcrumbModule } from './breadcrumb/breadcrumb.module';
import { FloatButtonsComponent } from './components/float-buttons/float-buttons.component';
import { FooterNavigationComponent } from './components/footer-navigation/footer-navigation.component';
import { GlobalNavigationComponent } from './components/global-navigation/global-navigation.component';
import { LocalNavigationComponent } from './components/local-navigation/local-navigation.component';
import { StandardNavigationComponent } from './components/standard-navigation/standard-navigation.component';
// import {
//   FooterNavigationComponent, GlobalNavigationComponent,
//   LocalNavigationComponent,
//   StandardNavigationComponent
// } from './components';
import { DisableLinkDirective } from './directives/disable-link.directive';
import { MatListOptionOverrideDirective } from './directives/mat-list-option-override.directive';
// import { VirtualScrollerModule } from 'primeng/virtualscroller';

@NgModule({
  declarations: [
    LocalNavigationComponent,
    StandardNavigationComponent,
    GlobalNavigationComponent,
    FooterNavigationComponent,
    DisableLinkDirective,
    MatListOptionOverrideDirective,
    FloatButtonsComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    ScrollingModule,
    MatCheckboxModule,
    MatListModule,
    AdBreadcrumbModule,
    ADSharedModule,
    ADInputModule,
    ADButtonModule,
    VirtualScrollerModule
  ],
  exports: [
    LocalNavigationComponent,
    StandardNavigationComponent,
    GlobalNavigationComponent,
    FooterNavigationComponent,
    DisableLinkDirective,
    AdBreadcrumbModule,
    FloatButtonsComponent
  ]
})
export class ADNaviModule { }
